import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { QueryParamUtil } from '../../utils/query-param-util';

export const RedirectToBench = () => {
  const { accountId } = QueryParamUtil.getQueryParams();
  const navigate = useNavigate();

  useEffect(() => {
    if (accountId) {
      navigate(`/account/${accountId}/my-bench`, { replace: true });
    }
  }, [navigate, accountId]);

  return null;
};
